import React from 'react';
import styled from '@emotion/styled';

export const Root = styled.div`
  margin: 0 auto;
  text-align: center;
  .madisonFaces {
    color: #0318c6;
    font-family: Syne;
    font-size: 34px;
    margin-bottom: 0px;
    margin-top: 50px;
  }
  .decadesTag {
    color: #000;
    font-size: 20px;
    font-weight: 300;
    line-height: 35px;
    margin-top: 18px;
    text-align: center;
  }
  .ourValuesWrap {
    position: relative;
  }
  @media (min-width: 1024px) {
    .lastSectionOuterWrap {
      justify-content: center;
      > div:first-of-type {
        margin-left: 0;
      }
    }
    .madisonFaces {
      font-size: 50px;
      margin-bottom: -20px;
      margin-top: 20px;
    }
    .decadesTag {
      font-size: 24px;
      line-height: 42px;
      margin-top: 30px;
    }
    .ourValuesWrap {
      padding: 0 24px;
    }
  }
  @media (min-width: 1440px) {
    .lastSectionOuterWrap {
      justify-content: center;
      > div:first-of-type {
        margin-left: 0;
      }
    }
    .madisonFaces {
      font-size: 50px;
      margin-bottom: -20px;
      margin-top: 120px;
    }
    .decadesTag {
      font-size: 24px;
      line-height: 42px;
      margin-top: 30px;
    }
    .ourValuesWrap {
      padding: 0 24px;
    }
  }
`;

export const SectionOneWrap = styled.div`
  background: linear-gradient(171deg, #efeff2 43%, #fff 57.61%, #fff 64.74%, #f2f2f2 79.54%);
  min-height: 996px;
  position: relative;
  z-index: 1;
  overflow: hidden;
  padding-bottom: 40px;
  .createsThe {
    color: #000;
    font-family: Syne;
    font-size: 34px;
    margin-top: 120px;
    position: relative;
    text-align: center;
    z-index: 6;
    padding: 0 24px;
  }
  .ourDedicated {
    color: #000;
    font-size: 24px;
    font-weight: 500;
    margin: 48px auto 0;
    padding: 0 24px;
    position: relative;
    text-align: center;
    text-transform: uppercase;
    z-index: 12;
    max-width: 338px;
  }
  .includingSixteen {
    color: #000;
    font-size: 20px;
    font-weight: 300;
    line-height: 35px;
    margin: 40px auto 0;
    padding: 0 45px;
    max-width: 882px;
    max-width: 480px;
    position: relative;
    text-align: center;
    z-index: 12;
  }
  .largeMotif {
    display: none;
  }
  .largeMotifMobile {
    top: -60px;
    left: 17px;
    width: 235px;
    height: auto;
    position: absolute;
    z-index: 1;
  }
  .intsyMotif {
    height: auto;
    position: absolute;
    right: 195px;
    top: -200px;
    transform: rotate(180deg);
    width: 398px;
    z-index: 1;
    display: none;
  }
  @media (min-width: 1024px) {
    background: var(--LINEAR, linear-gradient(90deg, #efeff2 0%, #fff 40%, #fff 59.5%, #f2f2f2 100%));
    min-height: 1265px;
    padding-bottom: 0;
    .largeMotifMobile {
      display: none;
    }
    .intsyMotif {
      display: block;
    }
    .createsThe {
      font-size: 50px;
      margin-top: 150px;
    }
    .largeMotif {
      position: absolute;
      display: block;
      z-index: 1;
      bottom: 0;
      left: 0;
    }
    .ourDedicated {
      font-size: 30px;
      font-weight: 500;
      margin-top: 102px;
      max-width: unset;
    }
    .includingSixteen {
      font-size: 24px;
      font-weight: 300;
      line-height: 42px;
      margin: 40px auto 0;
      max-width: 882px;
    }
  }
  @media (min-width: 1440px) {
    background: var(--LINEAR, linear-gradient(90deg, #efeff2 0%, #fff 40%, #fff 59.5%, #f2f2f2 100%));
    min-height: 1265px;
    padding-bottom: 0;
    .largeMotifMobile {
      display: none;
    }
    .intsyMotif {
      display: block;
    }
    .createsThe {
      font-size: 50px;
      margin-top: 150px;
    }
    .largeMotif {
      position: absolute;
      display: block;
      z-index: 1;
      bottom: 0;
      left: 0;
    }
    .ourDedicated {
      font-size: 30px;
      font-weight: 500;
      margin-top: 102px;
      max-width: unset;
    }
    .includingSixteen {
      font-size: 24px;
      font-weight: 300;
      line-height: 42px;
      margin: 40px auto 0;
      max-width: 882px;
    }
  }
`;

export const ClusterWrap = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 200px 20px 0px;
  position: relative;
  z-index: 5;
  .solidMotif {
    display: block;
    position: absolute;
    z-index: 8;
    width: 174px;
    height: auto;
  }
  .smallSolarSystem {
    display: block;
    position: absolute;
    z-index: 6;
    width: 541px;
    height: 541px;
    top: -60px;
    circle {
      stroke: rgba(220, 220, 220, 0.5);
    }
  }
  .headerText {
    color: #0318c6;
    font-family: Syne;
    font-style: normal;
    max-width: 324px;
    position: relative;
    font-size: 44px;
    line-height: 48px;
    text-align: center;
    z-index: 10;
  }
  @media (min-width: 1024px) {
    padding: 316px 0px 0px;
    .headerText {
      font-size: 84px;
      line-height: 84px;
      max-width: 620px;
    }
    .smallSolarSystem {
      width: 700px;
      height: 700px;

      top: unset;
    }
    .solidMotif {
      width: 224px;
      height: auto;
    }
  }
  @media (min-width: 1440px) {
    padding: 316px 0px 0px;
    .headerText {
      font-size: 84px;
      line-height: 84px;
      max-width: 620px;
    }
    .smallSolarSystem {
      width: 700px;
      height: 700px;

      top: unset;
    }
    .solidMotif {
      width: 224px;
      height: auto;
    }
  }
`;

export const BioCardsWrap = styled.div`
  align-items: center;
  column-gap: 20px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 20px auto 0;
  max-width: 1290px;
  row-gap: 24px;
  column-gap: 36px;
  .topTwo {
    display: flex;
    gap: 24px;
    justify-content: center;
    width: 100%;
    flex-wrap: wrap;
  }
  @media (min-width: 1024px) {
    column-gap: 36px;
    margin-top: 0px;
    max-width: 1024px;
    padding-left: 126px;
    padding-right: 126px;
    .yonahWrap {
      .socialyOff {
        gap: 8px;
      }
    }
    .topTwo {
      gap: 36px;
      > div {
        margin-top: 64px;
      }
    }
  }
  @media (min-width: 1440px) {
    column-gap: 36px;
    margin-top: 0px;
    max-width: 1440px;
    .yonahWrap {
      .socialyOff {
        gap: 8px;
      }
    }
    .topTwo {
      gap: 36px;
      > div {
        margin-top: 64px;
      }
    }
  }
`;

export const OurValuesWrap = styled.div`
  background-color: #f2f2f3;
  box-shadow: 0px 16px 32px 0px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 100px auto -10px;
  max-width: 1110px;
  padding: 40px 24px 64px;
  position: relative;
  text-align: center;
  width: 100%;
  z-index: 51;
  img {
    width: 280px;
    height: auto;
    margin-left: -80px;
  }
  .ourValuesHeader {
    font-size: 17px;
    font-weight: 500;
    text-transform: uppercase;
  }
  .ourValuesText {
    color: #000;
    font-family: Syne;
    font-size: 33px;
    font-weight: 300;
    line-height: 36px;
    margin-top: 16px;
    max-width: 538px;
    text-align: center;
    letter-spacing: 0.01px;
  }
  a {
    text-align: center;
    justify-content: center;
    gap: 18px;
    margin: 32px auto 0;
    background-color: #55dcac;
    :hover {
      background-color: #31b08d;
    }
  }
  @media (min-width: 1024px) {
    background-color: #f2f2f3;
    box-shadow: 0px 16px 32px 0px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: row;
    gap: 60px;
    margin: 240px auto -300px;
    max-width: 1110px;
    padding-left: 47px;
    padding-top: 170px;
    padding-left: 150px;
    position: relative;
    text-align: left;
    width: 100%;
    z-index: 20;
    align-items: flex-start;
    .ourValuesText {
      text-align: left;
      font-family: Syne;
      font-size: 35px;
      font-weight: 300;
      line-height: 40px;
      margin-top: 20px;
      max-width: 538px;
    }
    a {
      text-align: center;
      justify-content: center;
      gap: 18px;
      margin-top: 40px;
      margin-left: 0;
    }
    img {
      width: 350px;
    }
  }
  @media (min-width: 1440px) {
    background-color: #f2f2f3;
    box-shadow: 0px 16px 32px 0px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: row;
    gap: 60px;
    margin: 240px auto -300px;
    max-width: 1110px;
    padding-left: 47px;
    padding-top: 170px;
    padding-left: 150px;
    position: relative;
    text-align: left;
    width: 100%;
    z-index: 20;
    align-items: flex-start;
    .ourValuesText {
      text-align: left;
      font-family: Syne;
      font-size: 35px;
      font-weight: 300;
      line-height: 40px;
      margin-top: 20px;
      max-width: 538px;
    }
    a {
      text-align: center;
      justify-content: center;
      gap: 18px;
      margin-top: 40px;
      margin-left: 0;
    }
    img {
      width: 350px;
    }
  }
`;

export const DiscoverText = styled.div`
  color: #000;
  font-size: 34px;
  font-family: Syne;
  margin-top: 74px;
  text-align: center;
  padding: 0 20px;
  position: relative;
  z-index: 27;
  @media (min-width: 1024px) {
    font-size: 50px;
    margin: 0 auto;
    width: 1000px;
    position: absolute;
    top: 110px;
    right: 50%;
    transform: translateX(50%);
    z-index: 27;
  }
  @media (min-width: 1440px) {
    font-size: 50px;
    margin: 0 auto;
    width: 1000px;
    position: absolute;
    top: 100px;
    right: 50%;
    transform: translateX(50%);
    z-index: 27;
  }
`;

export function Silhouette({ ...props }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      data-name='Layer 1'
      viewBox='0 0 480.6 434.07'
      {...props}
    >
      <path
        d='M0 434.07c2.27-13.11 4.31-26.26 6.87-39.31 1.87-9.53 4.28-18.96 6.75-28.36 1.47-5.59 2.96-11.3 5.45-16.47 2.82-5.86 7.13-10.76 13.46-13.43 6.5-2.74 12.81-5.98 19.43-8.39 9.91-3.61 20.03-6.65 30.04-10.01 5.83-1.96 11.6-4.1 17.42-6.07 4.88-1.65 9.83-3.12 14.71-4.77 9.36-3.17 18.7-6.39 28.03-9.64 3.44-1.2 6.79-2.69 10.28-3.72 3.52-1.03 5.24-3.81 7.42-6.33 2.47-2.85 2.2-5.67 1.37-8.99-1.31-5.24-1.88-10.67-3.31-15.86-1.69-6.17-4.09-12.08-8.01-17.3-4.74-6.32-9.47-12.66-13.85-19.22-4.06-6.08-8.02-12.4-9.66-19.57-1.3-5.7-1.5-11.67-1.9-17.54-.29-4.14-.11-8.32-.13-12.48-.03-5.74.19-11.49-.19-17.2-.18-2.72-1.52-5.36-2.34-8.03-.17-.56-.46-1.1-.53-1.66-.61-5-1.28-10-1.69-15.02-.13-1.55.6-3.16.78-4.76.12-1.05.11-2.16-.07-3.2-1.27-7.13-2.94-14.21-3.83-21.38-1.36-10.99.11-21.75 3.69-32.25.89-2.6 2.25-5.23 1.11-8.17-.15-.38.03-1.01.27-1.39 2.16-3.44 4.62-6.72 6.5-10.29 1.82-3.45 4.14-6.68 4.25-10.99.04-1.52 2.32-3.2 3.88-4.41 2.92-2.27 6.07-4.26 9.13-6.37.2-.14.41-.3.64-.38 7.37-2.37 11.97-8.34 17.46-13.21 4.74-4.21 9.77-8.15 14.99-11.75 2.45-1.69 5.57-2.64 8.53-3.31 5.26-1.18 10.6-2.28 15.96-2.68 4.59-.35 9.28.16 13.9.59 3.96.37 7.92 1.01 11.82 1.81 8.36 1.71 16.81 3.16 24.97 5.56 7.22 2.12 14.11 5.43 20.14 10.07 1.81 1.39 3.25 3.52 4.29 5.6 3.83 7.66 8.63 14.66 13.59 21.62 2.61 3.66 4.2 8.05 6.23 12.11.66 1.31 1.19 2.69 1.92 3.96.72 1.26 1.62 2.43 2.45 3.63 2.28 3.34 4.7 6.59 4.7 10.95 0 1.27.52 2.55.84 3.81.16.64.62 1.27.56 1.87-.49 5.37 2.67 9.81 3.72 14.78.11.53.36 1.05.39 1.59.17 2.87.46 5.75.4 8.62-.07 3.02-.27 6.07-.83 9.02-.5 2.65-1.73 5.17-2.3 7.81-.18.83.49 2.09 1.15 2.81 3.31 3.59 4.02 7.98 4.66 12.59.84 6.06-1.47 11.43-2.95 17-1.47 5.54-2.93 11.09-4.47 16.61-1.47 5.26-2.75 10.6-4.65 15.71-1.44 3.88-4.93 5.49-9.09 4.97-1.33-.17-2.11.09-2.37 1.44-1.6 8.32-3.63 16.59-4.65 24.99-.59 4.87.29 9.94.81 14.89.14 1.32 1.24 2.66 2.2 3.73 2 2.24 4.11 4.33 4.7 7.46.29 1.57 1.48 2.18 2.79 3.09 2.79 1.93 5.55 4.27 7.47 7.04 5.2 7.5 9.91 15.33 14.89 22.98 1.9 2.91 3.69 5.98 6.07 8.47 2.35 2.47 5.12 4.81 8.15 6.33 8.54 4.27 17.34 8.03 25.99 12.09 8.19 3.84 16.26 7.97 24.52 11.66 3.84 1.71 8 2.68 12.01 4.01 6.24 2.07 12.45 4.2 18.7 6.22 4.27 1.38 8.67 2.42 12.85 4 4.95 1.88 9.58 4.74 14.64 6.17 6.43 1.82 10.77 6.06 15.09 10.6 3.96 4.16 5.85 9.45 7.62 14.7 3.11 9.22 6.06 18.5 8.72 27.86 2.27 7.98 5.07 34.09 6.96 42.18.24 1.03-.06 2.33-.48 3.35-2.45 5.94-6.49 10.61-11.75 14.25-.61.42-1.19.9-1.78 1.35-155.5 0-312-18-467.5-18Z'
        data-name='yzEjEq.tif'
        style={{
          fill: '#e7e7f1',
          strokeWidth: 0,
        }}
      />
    </svg>
  );
}
